import React from 'react';

function AboutUs() {
  return (
    <>
      <div className="font-popins mt-[100px]">
        <div className="grid lg:grid-cols-2 items-center lg:gap-y-6 bg-transparent">
          <div className="max-lg:order-1 max-lg:text-center sm:p-12 p-4">
            <h2 className="text-btn-color lg:text-5xl text-3xl font-bold lg:!leading-[56px]">
              About Us
            </h2>
            <p className="text-white mt-6 text-base leading-relaxed">
              Welcome to <strong className="text-lg mb-2 text-btn-color">FinzAid.com</strong>, your trusted
              partner in navigating the ever-evolving world of
              finance and trading. At FinzAid, we believe in empowering traders of all levels with the tools, knowledge,
              and confidence to succeed in today's dynamic financial markets.
              <br /><br />
              With a focus on providing reliable, up-to-date insights, our platform offers a wide array of resources
              ranging from educational trading sessions to real-time market analysis.
              Whether you're a beginner looking to build a solid foundation or a seasoned professional seeking advanced
              strategies, we have something for everyone.
              <br /><br />
              At <strong className="text-lg mb-2 text-btn-color">FinzAid.com</strong>, we prioritize
              transparency, security, and innovation. Our expert-led sessions are designed
              to provide actionable guidance, ensuring that you stay informed and make smart, data-driven decisions. Our
              team of industry professionals is dedicated to supporting you every step of the way,
              from personalized one-on-one coaching to interactive live webinars.
              <br /><br />
              Join us and become a part of a growing community of traders who are committed to mastering the art of
              trading. Together, we aim to make financial success achievable for all, no matter your background or
              experience level.
            </p>
          </div>

          <div className="lg:h-[480px] flex items-center">
            <img src="https://cdn.finzaid.com/finzaid-about-us.webp" className="w-full h-full object-cover" alt="Team" />
          </div>
        </div>


        {/* Updated grid for 2x2 layout */}
        <div className="grid lg:grid-cols-2 md:grid-cols-2 gap-6 px-4 my-12">
          <div className="bg-gray-100 p-6 rounded-md">
            <h3 className="text-lg font-bold mb-2 text-btn-color">Who We Are</h3>
            <p className="text-sm text-gray-600">
              <strong>FinzAid</strong> is a comprehensive platform created by a team of industry-leading professionals
              with expertise in finance, trading, web law, and cybersecurity.
              Our mission is to provide traders with the tools and knowledge they need to succeed in today's fast-paced
              financial markets.
              We offer a wide array of educational resources, including financial fundamentals, in-depth market
              analysis, and expert-led trading sessions.
              <br /><br />
              Our platform is designed to cater to both beginners and seasoned traders, offering:
              <ul className="list-disc list-inside">
                <li><strong>Financial Fundamentals</strong> – Master the core concepts that drive global markets, from
                  basic economic principles to advanced financial strategies.
                </li>
                <li><strong>Trading Lessons</strong> – Gain hands-on experience with our structured trading lessons that
                  cover everything from market analysis to executing trades.
                </li>
                <li><strong>Live Trading Sessions</strong> – Join our expert-led live trading sessions where you can see
                  real-time market movements and learn from seasoned traders.
                </li>
                <li><strong>Market Insights & Analysis</strong> – Stay informed with up-to-date financial news, expert
                  opinions, and in-depth analysis to guide your trading decisions.
                </li>
              </ul>
              <br />
              Our team includes:
              <ul className="list-disc list-inside">
                <li><strong>Financial Experts</strong> with years of experience in market analysis, trading strategies,
                  and investment management.
                </li>
                <li><strong>Web Law Professionals</strong> ensuring that our platform adheres to global legal standards,
                  protecting your interests and rights at every step.
                </li>
                <li><strong>Cybersecurity Specialists</strong> dedicated to safeguarding your personal and financial
                  data, using the latest security measures to ensure your peace of mind.
                </li>
              </ul>
              <br />
              At <strong>FinzAid</strong>, we combine education, expert insights, and secure practices to empower
              traders of all levels. Whether you're just starting or looking to refine your skills, we are here to
              support your journey in the financial markets.
              <br /><br />
              We believe that knowledge is power, and through our reliable resources and secure platform, we aim to
              provide you with everything you need to make informed, confident trading decisions. Trust FinzAid to be
              your partner in mastering the financial world.
            </p>


          </div>

          <div className="bg-gray-100 p-6 rounded-md">
            <h3 className="text-lg font-bold mb-2 text-btn-color">Our Mission</h3>
            <p className="text-sm text-gray-600">
              At <strong>FinzAid</strong>, our mission is to empower individuals and traders by providing comprehensive
              financial education, practical trading lessons, and expert market insights.
              We are dedicated to helping you achieve success in the financial markets by equipping you with the
              knowledge and skills necessary to make informed and strategic trading decisions.
              <br /><br />
              Our commitment to your success is matched by our unwavering focus on security. In today’s digital world,
              trust and safety are paramount, which is why we prioritize maintaining a secure and transparent platform
              for all users. We ensure that every piece of financial information you access is not only reliable but
              also safeguarded by industry-leading cybersecurity practices.
              <br /><br />
              Our mission is driven by three core pillars:
              <ul className="list-disc list-inside">
                <li><strong>Financial Education</strong> – We believe that education is the foundation of successful
                  trading. Our resources are designed to simplify complex financial concepts, making them accessible to
                  traders of all levels.
                </li>
                <li><strong>Empowering Traders</strong> – Through personalized trading lessons, live market sessions,
                  and continuous guidance, we aim to empower traders to navigate the financial markets with confidence
                  and independence.
                </li>
                <li><strong>Security and Trust</strong> – We uphold the highest standards of cybersecurity to protect
                  your personal and financial data, ensuring a safe trading environment where you can focus on learning
                  and growing without worry.
                </li>
              </ul>
              <br />
              By combining these pillars, <strong>FinzAid</strong> is dedicated to not only enhancing your financial
              knowledge but also ensuring that you can trade in a safe, supportive, and transparent space. Whether you
              are a novice trader or a seasoned expert, our mission is to provide you with the tools, insights, and
              security needed to thrive in the financial world.
            </p>
          </div>

        </div>
      </div>
    </>
  );
}

export default AboutUs;
